<template>
	<div id="app" :class="{ 'Backcolor': $route.meta.Backcolor, 'app_pab': $route.meta.showAppPaddB, h100: $route.meta.appHeight } ">
		<keep-alive>
			<!-- 头部导航 -->
			<HeaderNav v-if="!$route.meta.noNavigation" />
			<!-- 头部导航 -->
		</keep-alive>
		<div class="HeaderNavDiv" v-if="!$route.meta.noNavigation"></div>
    <keep-alive >
			<router-view class="container" v-if="$route.meta.alive"> </router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.alive" class="container"> </router-view>
		<keep-alive>
			<!-- 底部菜单 -->
			<FooterNav v-if="$route.meta.keepAlive" />

			<!-- 底部菜单 -->
		</keep-alive>
	</div>
</template>
<script>

	import FooterNav from "./components/FooterNav"
	import HeaderNav from "./components/HeaderNav"
	export default {
		components: {
			FooterNav,
			HeaderNav
		},

		data() {
			return {
				index: 0,
			}
		},
		mounted() {
			
		},
	}
</script>
<style lang="less">
	.app_pab {
		padding-bottom: calc(60px + constant(safe-area-inset-bottom));
		padding-bottom: calc(60px + env(safe-area-inset-bottom));
		box-sizing: border-box;
	}

	.HeaderNavDiv {
		height: 47px;
		// line-height: 1.226667rem;
		text-align: center;
		// background: #fff;
		-webkit-user-select: none;
		user-select: none;
	}

	.home_contain {
		padding-bottom: 20px;
		box-sizing: border-box;
	}
	.Backcolor {
		background: @pages;
		position: relative;
		min-height: 100%;
	}
  #nodes img{
    max-width: 100%;
    width: auto!important;
    display: inline-block;
  }
</style>